module.exports = __webpack_public_path__ + "static/img/login_logo.a623176.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_logo.png
// module id = ERDW
// module chunks = 3